import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/student/importer/studentImporterActions'

export default importerReducers(actions)
